import { post } from './client';
import { API_ENDPOINTS } from '../config/api';

export interface Demographics {
  first_name?: string | null;
  last_name?: string | null;
  address_1?: string | null;
  address_2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  phone?: string | null;
}

interface GetProfileResponse {
  demographics?: Demographics;
  error?: {
    message?: string;
  };
}

interface SetProfileResponse {
  success?: boolean;
  error?: {
    message?: string;
  };
}

export async function getProfile(loginKey: string) {
  return post<GetProfileResponse>(API_ENDPOINTS.DEMOGRAPHICS, {
    login_key: loginKey,
    method: 'get',
  });
}

export async function setProfile(loginKey: string, profile: Demographics) {
  const demographics: Record<string, string> = {};

  Object.entries(profile).forEach(([key, value]) => {
    if (typeof value === 'string') {
      demographics[key] = value;
    }
  });

  return post<SetProfileResponse>(API_ENDPOINTS.DEMOGRAPHICS, {
    login_key: loginKey,
    method: 'set',
    demographics,
  });
}

export default {
  getProfile,
  setProfile,
};
